module.exports = __webpack_public_path__ + "img/donate.89000a35.png";